
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import { useLoading } from 'SharedDir/common/composables/useLoading';

export default defineComponent({
  name: 'InformationHeader',
  setup() {
    const router = useRouter();
    const loading = useLoading();

    const toIndex = async () => {
      if (loading.action.state.value) {
        return;
      }

      loading.action.show();
      await router.push({
        name: 'main',
      });
      loading.action.hide();
    };

    return {
      toIndex,
      loading: loading.action.state,
    };
  },
});
